import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { getCookie } from "../utilities/cookies";
import { env } from "../utilities/function";

const authorizeContext = createContext();

// const authServer = axios.create({
//   baseURL: env("AUTHENTICATION_SERVER"),
// });

// const accessToken = getCookie("accessToken");
// authServer.defaults.headers.Authorization = `Bearer ${accessToken}`;

const AuthorizationProvider = ({ children }) => {
  const [content, setContent] = useState(children);
  const [user, setUser] = useState({});

  const authorize = async (loggedIn, cb) => {
    if (loggedIn) {
      setContent(children);
      if (typeof cb === "function") cb(setUser);
      return;
    }
    setContent(children);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = getCookie("accessToken");
    if (user && token) {
      setUser(JSON.parse(user));
      authorize(true, (setUser) => setUser(JSON.parse(user)));
    } else {
      authorize(false);
    }
  }, []);

  return (
    <authorizeContext.Provider value={{ authorize, setUser, user, setContent }}>
      {content}
    </authorizeContext.Provider>
  );
};

const useAuthorize = () => useContext(authorizeContext).authorize;
const useUser = () => useContext(authorizeContext).user;
const useSetUser = () => useContext(authorizeContext).setUser;
const useSetContent = () => useContext(authorizeContext).setContent;

export default AuthorizationProvider;
export { useAuthorize, useSetContent, useSetUser, useUser };
